import { userData } from "util/userData"
import { HttpRequest } from "util/http"
import {
  IColumn,
  IDropdownOption,
  IHierarchyOption,
  IRankingReportRecord,
  IRankingReport,
  IMeasureOption, IDropdownsResponse
} from './interfaces';

export const createReport = (name: string, reportDefinition: string, userId: number, isPreview: boolean = false) => {
  const data = { name, reportDefinition, userId, isPreview };
  const method = 'POST';
  return HttpRequest.fetch('scripts/ranking_reports/report/saveReport', { data, method })
    .then((res: number | boolean) => {
      return res;
    });
}

export const updateReport = (name: string, reportDefinition: string, userId: number, reportId: number) => {
  let data = { name: name, reportDefinition: reportDefinition, userId: userId, reportId: reportId };
  const method = 'POST';
  return HttpRequest.fetch('scripts/ranking_reports/report/saveReport', { data, method })
    .then((res: number | boolean) => {
      return res;
    });
}

// todo: delete unused function
export const getReport = (reportID: number) => {
  let data = { reportID: reportID };
  const method = 'POST';
  return HttpRequest.fetch('scripts/ranking_reports/report/getReport', { data, method })
    .then((res: IColumn[]) => {
      return res;
    });
}


export const validateReportName = (reportName: string) => {
  let data = { reportName: reportName };
  const method = 'POST';
  return HttpRequest.fetch('scripts/ranking_reports/report/validateReportName', { data, method })
    .then((res: boolean) => {
      return res;
    });
}


export const getHierarchy = (current: string, userId: number) => {
  let data = { project: userData.getCurrentProject(), hier: current, userId: userId };
  const method = 'POST';
  return HttpRequest.fetch('scripts/reports/getHierarchyDropdowns', { data, method })
    .then((res: IDropdownsResponse) => {
      return res;
    });
}

/**
 * Get options to populate Period Dropdown
 */
export const getPeriodOptions = () => {
  let data = { current_project: userData.getCurrentProject() };
  const method = 'POST';
  return HttpRequest.fetch('/scripts/ranking_reports/getPeriods', { data, method })
    .then((res: IDropdownOption[]) => {
      return res;
    });
}

/**
 * Get options to populate Surveys Dropdown
 */
export const getSurveysOptions = (hierarchyLevel: string) => {
  let data = { current_project: userData.getCurrentProject(), hierarchyLevel: hierarchyLevel };
  const method = 'POST';
  return HttpRequest.fetch('/scripts/ranking_reports/getSurveys', { data, method })
    .then((res: IDropdownOption[]) => {
      return res;
    });
}

/**
 * Get options to populate Surveys Dropdown
 */
export const getQuestionOptions = (survey: string) => {
  let data = { current_project: userData.getCurrentProject(), survey: survey };
  const method = 'POST';
  return HttpRequest.fetch('/scripts/ranking_reports/getQuestions', { data, method })
    .then((res: IDropdownOption[]) => {
      return res;
    });
}

/**
 * Get options to populate Measure Dropdown
 */
export const getMeasureOptions = (survey: string, question: string) => {
  let data = { current_project: userData.getCurrentProject(), survey: survey, question: question };
  const method = 'POST';
  return HttpRequest.fetch('/scripts/ranking_reports/getMeasures', { data, method })
    .then((res: IDropdownOption[]) => {
      return res;
    });
}
/**
 * Get options to populate Segments Dropdown
 */
export const getSegmentOptions = (survey: string, question: string) => {
  let data = { current_project: userData.getCurrentProject(), survey: survey, question: question };
  const method = 'POST';
  return HttpRequest.fetch('/scripts/ranking_reports/getSegments', { data, method })
    .then((res: IDropdownOption[]) => {
      return res;
    });
}

/**
 * Get records for one single column
 */
export const getColumnResults = (columnDefinition: string, requestedAvidsIds: string) => {
  let data = { current_project: userData.getCurrentProject(), columnDefinition: columnDefinition, requestedAvidsIds: requestedAvidsIds };
  const method = 'POST';
  return HttpRequest.fetch('/scripts/ranking_reports/report/runColumnReport', { data, method })
    .then((res: IColumn) => {
      return res;
    });
}

/**
 * Get report
 */
export const getReportDefinition = (reportId: number) => {
  let data = { current_project: userData.getCurrentProject(), reportId: reportId };
  const method = 'POST';
  return HttpRequest.fetch('/scripts/ranking_reports/report/getReport', { data, method })
    .then((res: IRankingReport) => {
      return res;
    });
}

/**
 * Make a hard delete for the selected Ranking Report
 */
export const hardDeleteReport = (reportId: number) => {
  let data = { current_project: userData.getCurrentProject(), reportID: reportId };
  const method = 'POST';
  return HttpRequest.fetch('/scripts/ranking_reports/report/hardDeleteReport', { data, method })
    .then((res: IRankingReport) => {
      return res;
    });
}

/**
 * Get report
 */
export const getCalculationPrecision = (survey: string, question: string) => {
  let data = { current_project: userData.getCurrentProject(), survey: survey, question: question };
  const method = 'POST';
  return HttpRequest.fetch('/scripts/ranking_reports/getMeasures', { data, method })
    .then((res: IDropdownOption[]) => {
      return res;
    });
}
